import { useAdminInvoiceReportApprovalRoute } from '@/context/services/admin_invoice_reports/AdminInvoiceReportApprovalRoute.service';
import { handleAdminInvoiceReportsAccessError } from '@/context/services/admin_invoice_reports/handleAdminInvoiceReportsAccessError';
import { useTranslation } from '@/i18n';
import { useToastAPI } from '@moneyforward/ap-frontend-components';
import { useEffect } from 'react';

type UseApprovalRouteProps = {
  reportId: string;
  onCloseDetailDrawer: () => void;
};

export const useApprovalRoute = ({
  reportId,
  onCloseDetailDrawer,
}: UseApprovalRouteProps) => {
  const notify = useToastAPI();
  const { t } = useTranslation();
  const { data, error } = useAdminInvoiceReportApprovalRoute(reportId);

  useEffect(() => {
    if (!error) return;
    const statusCode = error.code ? Number(error.code) : undefined;
    if (error.code === '401' || error.code === '403') {
      handleAdminInvoiceReportsAccessError(statusCode, undefined);
      return;
    }
    const title = Array.isArray(error.messages)
      ? error.messages.join(',')
      : error.messages || t('system_error');
    notify.error({ title, duration: 3 });
    onCloseDetailDrawer();
  }, [error, notify, t, onCloseDetailDrawer]);

  return { data };
};
